import React from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import moment from "moment";
import { deptmentList } from "./jobRegisterConst";
import { services } from "./jobConstant";
import { Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import { CancelButton } from "../../utils/commonComponent/Custom/Button";

// Configuration for compliance types
const COMPLIANCE_CONFIGS = [
  {
    key: 'workmen_comp_policy',
    label: 'Workmen Compensation Policy',
    fields: [
      { key: 'workmen_comp_policy_number', label: 'Policy Number', type: 'text' },
      { key: 'workmen_comp_policy_start', label: 'Start Date', type: 'date' },
      { key: 'workmen_comp_policy_end', label: 'End Date', type: 'date' },
      { key: 'workmen_comp_document', label: 'View Workmen Policy', type: 'file' }
    ]
  },
  {
    key: 'insurance_policy',
    label: 'Insurance',
    fields: [
      { key: 'insurance_policy_number', label: 'Policy Number', type: 'text' },
      { key: 'insurance_policy_start', label: 'Start Date', type: 'date' },
      { key: 'insurance_policy_end', label: 'End Date', type: 'date' },
      { key: 'insurance_document', label: 'View Policy', type: 'file' }
    ]
  },
  {
    key: 'pbg_policy',
    label: 'PBG',
    fields: [
      { key: 'pbg_amount', label: 'Amount', type: 'text' },
      { key: 'pbg_policy_start', label: 'Start Date', type: 'date' },
      { key: 'pbg_policy_end', label: 'End Date', type: 'date' },
      { key: 'pbg_document', label: 'View PBG', type: 'file' }
    ]
  },
  {
    key: 'bg_policy',
    label: 'BG',
    fields: [
      { key: 'bg_amount', label: 'Amount', type: 'text' },
      { key: 'bg_policy_start', label: 'Start Date', type: 'date' },
      { key: 'bg_policy_end', label: 'End Date', type: 'date' },
      { key: 'bg_document', label: 'View BG', type: 'file' }
    ]
  },
  {
    key: 'retention',
    label: 'Retention',
    fields: [
      { key: 'retention_percentage', label: 'Percentage (%)', type: 'text' }
    ]
  },
  {
    key: 'labour_license',
    label: 'Labour License',
    fields: [
      { key: 'labour_license_document', label: 'View License', type: 'file' }
    ]
  },
  {
    key: 'car_policy',
    label: 'CAR Policy',
    fields: [
      { key: 'car_policy_number', label: 'Policy Number', type: 'text' },
      { key: 'car_policy_start', label: 'Start Date', type: 'date' },
      { key: 'car_policy_end', label: 'End Date', type: 'date' },
      { key: 'car_policy_document', label: 'View Car Policy', type: 'file' }
    ]
  },
  {
    key: 'emd',
    label: 'EMD',
    fields: [
      { key: 'emd_description', label: 'Description', type: 'text' },
      { key: 'emd_amount', label: 'Amount', type: 'text' },
      { key: 'emd_document', label: 'View EMD', type: 'file' }
    ]
  },
  {
    key: 'dlp',
    label: 'DLP',
    fields: [
      { key: 'dlp_period_description', label: 'Period (Description)', type: 'text' }
    ]
  }
];

const ViewJobRegister = ({ inputStates = {}, employees = [], workOrders = [], permissions }) => {
  const hasPermission = permissions?.viewDocument || permissions?.allAccess;
  
  // File download handler
  const handleDownload = (fileUrl) => {
    if (!fileUrl) return;

    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        // Extract filename from URL
        const fileName = fileUrl?.split("/")?.pop() || "downloaded_file";
        link.setAttribute("download", fileName);

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => console.error("Download error:", err));
  };

  // Helper functions
  const getEmployeeName = (empId) => {
    const emp = employees.find((e) => e.id == empId);
    return emp ? `${emp.employeesCode || ""} - ${emp.name || ""}` : "-";
  };

  const getDepartmentNames = () => {
    const selectedIds = (inputStates.department || "")
      ?.split(",")
      ?.map(id => id.trim())
      ?.filter(Boolean);

    const depts = deptmentList.filter(dept => selectedIds.includes(String(dept.id)));
    return depts.map(d => d.label).join(", ") || "-";
  };

  const getServiceNames = () => {
    const selectedIds = (inputStates.serviceId || "")
      ?.split(",")
      ?.map(id => id.trim())
      ?.filter(Boolean);

    const servs = services.filter(service => selectedIds.includes(String(service.id)));
    return servs.map(s => s.label).join(", ") || "-";
  };

  // Format field value based on type
  const formatFieldValue = (field, value) => {
    if (!value) return "-";

    switch (field.type) {
      case 'date':
        return value ? moment(value).format('DD-MM-YYYY') : "-";
    case "file":
  if (!value) return "-";

  const fileName = value?.split("/").pop();

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px", }}>
      <Tooltip title={fileName}>
        <VisibilityIcon
          style={{
            cursor: "pointer",
            color: hasPermission ? "#1976d2" : "#9e9e9e",
            fontSize: "1.5rem",
          }}
          onClick={() => {
            if (hasPermission) {
              window.open(value, "_blank");
            } else {
              toast.warning("You don’t have permission to view this file.");
            }
          }}
        />
      </Tooltip>
       {/* Download */}
      <Tooltip title="Download">
        <DownloadIcon
          style={{
            cursor: "pointer",
            color: hasPermission ? "#1976d2" : "#9e9e9e",
            marginTop: "4px",
            fontSize: "1.5rem",
          }}
          onClick={() => {
            if (hasPermission) {
              handleDownload(value);
            } else {
              toast.warning("You don’t have permission to download this file.");
            }
          }}
        />
      </Tooltip>
    </div>
  );

      default:
        return value;
    }
  };

  // Reusable field renderer
  const ViewField = ({ label, value }) => (
    <div className="p-2">
      <div className="text-md font-semibold text-gray-700">{label} : </div>
      <div className="text-base text-gray-900">{value || "-"}</div>
    </div>
  );

  // Section Header UI
  const SectionHeader = ({ title }) => (
    <div className="col-span-full mt-6">
      <div className="bg-blue-100 p-2 rounded border-l-4 border-blue-600">
        <div className="text-lg font-bold text-blue-700">{title}</div>
      </div>
    </div>
  );

  // Compliance Sub-Header (for each compliance type)
  const ComplianceSubHeader = ({ title }) => (
    <div className="col-span-full mt-4">
      <div className="bg-gray-100 p-2 rounded border-l-4 border-gray-500">
        <div className="text-base font-semibold text-gray-800">{title}</div>
      </div>
    </div>
  );

  // Dynamic Compliance Section Component
  const ComplianceSection = ({ config }) => {
    if (Number(inputStates[config.key]) !== 1) return null;

    return (
      <>
        <ComplianceSubHeader title={config.label} />
        {config.fields.map((field) => {
          const value = inputStates[field.key];
          const formattedValue = formatFieldValue(field, value);
          
          return (
            <ViewField 
              key={field.key}
              label={field.label} 
              value={formattedValue}
            />
          );
        })}
      </>
    );
  };

  return (
    <div className="p-2">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold text-blue-700">Job Register View</h2>

        <CancelButton
          id="btn-cancel"
          label="Close"
          onClick={() => {
            window.history.back();
          }}
        />
      </div>
      {/* GRID LAYOUT */}
      <div className="grid gap-5 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 bg-white p-3 rounded">
        {/* Basic Information */}
        <SectionHeader title="Basic Information" />
        <ViewField label="Job No" value={inputStates.jobNumber} />
        <ViewField label="Job Date" value={inputStates.jobDate ? moment(inputStates.jobDate).format("DD-MM-YYYY") : "-"} />
        <ViewField label="Client Initial" value={inputStates.clientInitials} />
        <ViewField label="Department" value={getDepartmentNames()} />
        <ViewField label="Project InCharge" value={getEmployeeName(inputStates.projectInchargeId)} />
        <ViewField label="Project HOD" value={getEmployeeName(inputStates.projectHodId)} />
        <ViewField label="Project Owner" value={getEmployeeName(inputStates.projectOwnerId)} />
        <ViewField label="Site Country" value={inputStates.country} />
        <ViewField label="Site State" value={inputStates.siteState} />
        <ViewField label="Site City" value={inputStates.siteCity} />
        <ViewField label="Service" value={getServiceNames()} />
        <ViewField label="Reference" value={inputStates.reference} />

        {/* Reporting Details */}
        <SectionHeader title="Reporting Details" />
        <ViewField label="Client Name" value={inputStates.clientName} />
        <ViewField label="Client Address" value={inputStates.address} />
        <ViewField label="PAN No" value={inputStates.panNo} />
        <ViewField label="GST No" value={inputStates.gstNumber} />
        <ViewField label="Principle Client" value={inputStates.principleClient} />
        <ViewField label="Contact Person Name" value={inputStates.contactPerson} />
        <ViewField label="Contact No" value={inputStates.ContactNo} />
        <ViewField label="Project Name" value={inputStates.projectName} />

        {/* Billing Details */}
        <SectionHeader title="Billing Details" />
        <ViewField label="Client Name" value={inputStates.billingClientName} />
        <ViewField label="Client Address" value={inputStates.billingAddress} />
        <ViewField label="PAN No" value={inputStates.billingpanNo} />
        <ViewField label="GST No" value={inputStates.billinggstNumber} />
        <ViewField label="Contact Person Name" value={inputStates.billingcontactPerson} />
        <ViewField label="Contact No" value={inputStates.billingContactNo} />

        {/* Work Order Details */}
        <SectionHeader title="Work Order Details" />

        <div className="col-span-full">
          <div className="overflow-x-auto border rounded bg-white shadow-sm">
            <table className="min-w-full text-sm">
              <thead className="bg-blue-100 text-blue-900 font-bold">
                <tr>
                  <th className="px-4 py-2 text-left">Sr.No.</th>
                  <th className="px-4 py-2 text-left">Work Order No</th>
                  <th className="px-4 py-2 text-left">Amendment No</th>
                  <th className="px-4 py-2 text-left">Amount</th>
                  <th className="px-4 py-2 text-left">Start Date</th>
                  <th className="px-4 py-2 text-left">End Date</th>
                  <th className="px-4 py-2 text-left">Document</th>
                </tr>
              </thead>
              <tbody>
                {workOrders.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="px-4 py-6 text-center text-gray-500">
                      No work orders found
                    </td>
                  </tr>
                ) : (
                  workOrders.map((wo, index) => (
                    <tr key={index} className="border-b hover:bg-gray-50 transition">
                      <td className="px-4 py-2">{index + 1}</td>
                      <td className="px-4 py-2">{wo.workOrderNo}</td>
                      <td className="px-4 py-2">{wo.amendment_No || "-"}</td>
                      <td className="px-4 py-2">{wo.workOrderAmount}</td>
                      <td className="px-4 py-2">{wo.start_Date ? moment(wo.start_Date).format("DD-MM-YYYY") : "-"}</td>
                      <td className="px-4 py-2">{wo.end_Date ? moment(wo.end_Date).format("DD-MM-YYYY") : "-"}</td>
                      <td className="px-4 py-2 flex items-center gap-2">
                        <Tooltip title={wo?.workDocument?.split("/")?.pop()}>
                        <VisibilityIcon
                          style={{
                            cursor: "pointer",
                            color: hasPermission ? "#1976d2" : "#9e9e9e",
                          }}
                          onClick={() => {
                            if (hasPermission) {
                              window.open(wo?.workDocument, "_blank");
                            } else {
                              toast.warning("You don’t have permission to view this file.");
                            }
                          }}
                        />
                        </Tooltip>
                        <Tooltip title="Download">
                          <DownloadIcon
                            style={{
                              cursor: "pointer",
                              color: hasPermission ? "#1976d2" : "#9e9e9e",
                              marginTop: "4px",
                            }}
                            onClick={() => {
                              if (hasPermission) {
                                handleDownload(wo.workDocument);
                              } else {
                                toast.warning("You don’t have permission to download this file.");
                              }
                            }} 
                          />
                        </Tooltip>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Compliances */}
        <SectionHeader title="Compliances" />

        <ViewField
          label="HR Compliances"
          value={inputStates.inclusionsHRComplaince ? "Yes" : "No"}
        />

        {/* Dynamic Compliance Sections - Each with its own sub-header */}
        {COMPLIANCE_CONFIGS.map((config) => (
          <ComplianceSection key={config.key} config={config} />
        ))}

      </div>
    </div>
  );
};

export default ViewJobRegister;